import { ReactNode, useMemo } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import { getTheme } from "./theme";

export const muiCache = createCache({
	key: "mui",
	prepend: true,
});

export interface ThemeProviderProps {
	/**
	 * a node to be rendered in the special component.
	 */
	children?: ReactNode;
}

const ThemeProvider = ({ children }: ThemeProviderProps) => {
	const theme = useMemo(() => getTheme(), []);

	return (
		<CacheProvider value={muiCache}>
			<MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
		</CacheProvider>
	);
};

export default ThemeProvider;
